import service from "@/utils/request";

// 目录结构列表
export const getCatalogTreeApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/catalog_tree",
    method: "get",
    params,
  });
};

// 文档详情
export const getDocDetailApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/doc_detail",
    method: "get",
    params,
  });
};

// 最近访问文档列表
export const getDocVisitListApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/doc_visit_list",
    method: "get",
    params,
  });
};
// 获取文档uuid
export const getDocUuidApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/get_latest_catalog_uuid",
    method: "get",
    params,
  });
};

// 最近下载记录
export const getDocDownloadListApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/doc_attach_download_list",
    method: "get",
    params,
  });
};

// 文档路径
export const getDocPositionApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/doc_position",
    method: "get",
    params,
  });
};

// 获取最新文档id
export const getLatestDocIdApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/get_latest_doc_id",
    method: "get",
    params,
  });
};

// 搜索
export const handleSearchApi = (params: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/search",
    method: "get",
    params,
  });
};

// 附件下载记录添加
export const handleDocDownloadAddApi = (data: any) => {
  return service({
    url: "/api/v1/wiki/wow_college/doc_attach_download_add",
    method: "post",
    data,
  });
};
